
import { AuthService } from "@/services/auth-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			step: 0,
			password: "",
			confirmOtp: "",
			imageUrl: "",
			backupCodes: [] as string[],
			buttonsDisabled: false
		};
	},
	computed: {
		nextButtonText():string{
			if (this.step == 2){
				return this.$ct("common.finish").toString();
			}
			return this.$ct("common.next").toString();
		},
		valid():boolean{
			if (this.step == 0 && this.password == ""){
				return false;
			}
			if (this.step == 1 && !/^[0-9]{6}$/.test(this.confirmOtp)) {
				return false;
			}
			return !this.buttonsDisabled;
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			if (!this.valid) return;
			this.buttonsDisabled = true;
			try{
				if (this.step == 2){
					await this.finish();
				}
				if (this.step == 1){
					await this.requestValidation();
				}
				if (this.step == 0){
					await this.enable();
				}
			}catch(err){
			}
			this.buttonsDisabled = false;
		},
		onOtpInput(value:string){
			let oldValue = this.confirmOtp;
			this.confirmOtp = value;
			if (!/^[0-9]{0,6}$/.test(value)){
				this.$nextTick(()=>{
					this.confirmOtp = oldValue;
				});
			}
		},
		async enable(){
			let blob = await AuthService.totpEnable(this.password);
			this.imageUrl = URL.createObjectURL(blob);
			this.step++;
		},
		async requestValidation(){
			this.backupCodes = await AuthService.totpValidate(this.confirmOtp.toString());
			this.step++;
		},
		async finish(){
			this.$emit("close");
		},
		async openUrl(url:string){
			window.open(url, "_blank");
		}
	},
	beforeDestroy(){
		if (this.imageUrl){
			URL.revokeObjectURL(this.imageUrl);
		}
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
